import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement } from 'react';

import { useTranslation } from 'next-i18next';
import { SettingLayout } from '../../../../FSD/shared/ui/layout/SettingLayout';
import NotificationSettingPageComponent from '../../../../components/pages/my/settings/notification/NotificationSettingPage';
import { NOTIFICATION_META } from '../../../../components/pages/my/settings/notification/constants';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

export default function NotificationSettingPage() {
  return <NotificationSettingPageComponent />;
}

function NotificationSettingPageLayout({ children }: { children: ReactElement }) {
  const { t } = useTranslation();
  return (
    <SettingLayout
      title={t(NOTIFICATION_META.title)}
      description={t(NOTIFICATION_META.description)}
      pageCategory={t('계정')}
    >
      {children}
    </SettingLayout>
  );
}

NotificationSettingPage.getLayout = (page: ReactElement) => (
  <NotificationSettingPageLayout>{page}</NotificationSettingPageLayout>
);
